import React from "react";
import { Link } from "react-router-dom";

export const ToolShell = ({ crumb, crumbTo, title, subtitle, children, testid }) => (
  <div data-testid={testid}>
    <section className="bp-grid border-b-2 border-ink">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
        <nav className="font-mono text-xs text-ink/50 mb-4">
          <Link to={crumbTo} className="hover:text-signal">{crumb}</Link> / {title}
        </nav>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter">{title}</h1>
        {subtitle && <p className="mt-3 text-lg text-ink/70">{subtitle}</p>}
      </div>
    </section>
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">{children}</div>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/50">{label}</span>
    <div className="mt-2">{children}</div>
  </label>
);

export const inputCls =
  "w-full font-mono text-lg border-2 border-ink bg-paper px-4 py-3 outline-none focus:border-signal focus:shadow-signal transition-all";

export const ResultBox = ({ label, value, sub, testid }) => (
  <div className="border-2 border-ink bg-ink text-paper p-7 shadow-brutal" data-testid={testid}>
    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-canvas/60">{label}</span>
    <div className="font-mono text-4xl sm:text-5xl font-bold text-signal mt-2 break-all">{value}</div>
    {sub && <p className="font-mono text-sm text-canvas/70 mt-2">{sub}</p>}
  </div>
);
